
shadow.loader.set_loaded();
frontend.main.init_BANG_();